import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getUniProtVariants } from "../../../../state/selectors/CardsUI.selectors";
import pathogenicityColors from "../../common/_pathogenicityColors.module.scss";
import { CLINICAL_SIGNIFICANCE_COLORS_STRINGS } from "../../common/constants";
import { sortByClinicalSignificance } from "../../common/helpers";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { PATHOGENICITY_COLORS_BY_STRING } from "../../../../common/helpers/Constant";

const UniProtCard = ({ card, uniProtVariants }) => {
  // TODO: Discuss about default uniprot card state and see if setting the default to open might create weird behavior at clinical
  const renderSignificance = () => {
    if (uniProtVariants) {
      const sortedClinicalSignificances = sortByClinicalSignificance(
        uniProtVariants.clinicalsignificances
      );
      // if less than 3 significances show all of them
      if (sortedClinicalSignificances.length < 3) {
        return (
          <b>
            {sortedClinicalSignificances.map((significance, i) => {
              const color =
                CLINICAL_SIGNIFICANCE_COLORS_STRINGS[
                  significance.toLowerCase()
                ];
              return (
                <b className={pathogenicityColors[color]} key={i}>
                  {significance.trim()}
                  {sortedClinicalSignificances.length - 1 === i ? "" : ", "}
                </b>
              );
            })}
          </b>
        );
      }

      // if more than 3 significances show conflicting and the first one
      return (
        <span data-testid="significance-more-than-3">
          Conflicting (
          <b
            className={
              pathogenicityColors[
                CLINICAL_SIGNIFICANCE_COLORS_STRINGS[
                  sortedClinicalSignificances[0].toLowerCase()
                ]
              ]
            }
          >
            {sortedClinicalSignificances[0].trim()}
          </b>
          )
        </span>
      );
    }
    return null;
  };

  const calcBackgroundColor = () => {
    let backgroundColor = "";

    if (uniProtVariants && uniProtVariants?.clinicalsignificances) {
      const sortedSignificances = sortByClinicalSignificance(
        uniProtVariants.clinicalsignificances
      );

      sortedSignificances.forEach((significance) => {
        if (
          CLINICAL_SIGNIFICANCE_COLORS_STRINGS[significance.toLowerCase()] &&
          !backgroundColor
        ) {
          backgroundColor =
            PATHOGENICITY_COLORS_BY_STRING[
              CLINICAL_SIGNIFICANCE_COLORS_STRINGS[significance.toLowerCase()]
            ];
        }
      });
    }
    return backgroundColor;
  };

  return (
    <CardWrapper
      {...card}
      isDisabled={!uniProtVariants}
      color={calcBackgroundColor()}
    >
      {uniProtVariants?.clinicalsignificances ? (
        <div>{renderSignificance()}</div>
      ) : null}
    </CardWrapper>
  );
};

UniProtCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  uniProtVariants: PropTypes.shape({
    clinicalsignificances: PropTypes.arrayOf(PropTypes.string),
  }),
};

UniProtCard.defaultProps = {
  uniProtVariants: null,
};

const mapStateToProps = (state) => {
  return {
    uniProtVariants: getUniProtVariants(state),
  };
};

export default connect(mapStateToProps)(UniProtCard);
